import React from "react";
import { Helmet } from "react-helmet";
import "./Affiliates.css";

export const Affiliates = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pageUrl = `${origin}/affiliates`;
  const description = "Join the FlintHost Affiliate Program to earn 15% commission on every referral with a standard tracking link.";
  return (
    <div className="affiliates-page">
      <Helmet>
        <title>FlintHost | Affiliates</title>
        <meta name="description" content={description} />
        <meta property="og:title" content="FlintHost | Affiliates" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={`${origin}/img/Logo2.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FlintHost | Affiliates" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={`${origin}/img/Logo2.png`} />
      </Helmet>
      <section className="affiliates-hero">
        <div className="affiliates-hero-content">
          <p className="affiliates-eyebrow">Affiliate Program</p>
          <h1>Earn 15% Commission</h1>
          <p>
            Share FlintHost with your audience and earn a 15% commission on every referral. Affiliates receive a standard tracking link.
          </p>
        </div>
        <div className="affiliates-hero-card">
          <h2>Standard affiliate link</h2>
          <p>Custom links are reserved for partners, but you can start earning immediately with the affiliate signup.</p>
          <a
            className="affiliates-cta"
            href="https://billing.flinthost.com/account/affiliate"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sign up as an affiliate
          </a>
        </div>
      </section>

      <section className="affiliates-section">
        <div className="affiliates-grid">
          <div className="affiliates-card">
            <h3>15% commission</h3>
            <p>Earn 15% on every qualified purchase you refer.</p>
          </div>
          <div className="affiliates-card">
            <h3>Fast signup</h3>
            <p>Create your affiliate account and start sharing in minutes.</p>
          </div>
          <div className="affiliates-card">
            <h3>Partner upgrades</h3>
            <p>Want a custom link? Apply for the partner program anytime.</p>
            <a className="affiliates-link" href="/partnerships">
              View partner program
            </a>
          </div>
        </div>
        <div className="affiliates-example">
          <h3>Example earnings</h3>
          <p>If someone buys a $20 server, you earn $3.</p>
        </div>
      </section>
    </div>
  );
};
